module.exports = __webpack_public_path__ + "static/media/mast-premium-photo-product.9c047d62.jpg";